import React from "react";
import Collapse from "../../assets/images/collapse_icon.svg";
const CollapseIcon = () => {
  return <img src={Collapse} alt="collapse_icon" />;
};
export default CollapseIcon;
